import Main from './Main.vue'

export default [{
  path: 'pregao-lance-cronometro/:id',
  name: 'pregaolance-cronometro',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-lance-cronometro/routes.js